var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNwSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.862,
    height: 25.4,
    viewBox: "0 0 58.862 25.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10863",
    "data-name": "Group 10863",
    transform: "translate(-2054.8 -471.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4976",
    "data-name": "Rectangle 4976",
    width: 11.455,
    height: 11.455,
    transform: "translate(2062.9 480.399) rotate(-45)",
    fill: "#c7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4977",
    "data-name": "Rectangle 4977",
    width: 11.4,
    height: 11.4,
    transform: "translate(2071.042 488.518) rotate(-45)",
    fill: "#9c0087"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4978",
    "data-name": "Rectangle 4978",
    width: 11.4,
    height: 11.4,
    transform: "translate(2089.428 488.513) rotate(-45)",
    fill: "#00a0e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4979",
    "data-name": "Rectangle 4979",
    width: 11.455,
    height: 11.455,
    transform: "translate(2080.2 479.3) rotate(-45)",
    fill: "#3e2b82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4980",
    "data-name": "Rectangle 4980",
    width: 11.455,
    height: 11.455,
    transform: "translate(2054.8 488.5) rotate(-45)",
    fill: "#f00082"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4981",
    "data-name": "Rectangle 4981",
    width: 11.4,
    height: 11.4,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 2097.54, 480.408)",
    fill: "#173183"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNwSmallLogo);
export default __webpack_public_path__ + "static/media/nw-small-logo.1d6074a64bc68de814fe65de764a2d21.svg";
export { ForwardRef as ReactComponent };